import React, { useEffect, useState } from 'react';
export function ProgressBar() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = windowHeight > 0 ? totalScroll / windowHeight * 100 : 0;
      setProgress(scroll);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 w-full h-[3px] z-[70] bg-transparent pointer-events-none" data-id="element-274">
      <div className="h-full bg-gradient-to-r from-primary via-accent to-gold transition-all duration-150 ease-out" style={{
      width: `${progress}%`
    }} data-id="element-275" />
    </div>;
}